/* ------------------------------------------------------------------------
Copyright (c) 2016, VoiceVibes, Inc

VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
All contents of this file are proprietary and confidential. No part of
any of the contents of this file may be disclosed in any manner to
a third party without the prior written consent of VoiceVibes, Inc.
Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <div
    class="row"
    aria-hidden="true"
  >
    <div class="col-sm-4 col-sm-offset-2 text-center">
      <span class="evaluate-label">
        Positive Vibes
      </span>
      <div class="chart-wrapper chart-wrapper-300">
        <div id="positiveVibesContainer">
          <recording-vibe
            tooltip-id="positiveVibesContainer"
            :recording="recording"
            :wavesurfer="wavesurfer"
            metric="positiveVibes"
            :speaker-num="speakerNum"
          />
        </div>
      </div>
    </div>
    <div class="col-sm-4 text-center">
      <span class="evaluate-label">
        Negative Vibes
      </span>
      <div class="chart-wrapper chart-wrapper-300">
        <div id="negativeVibesContainer">
          <recording-vibe
            tooltip-id="negativeVibesContainer"
            :recording="recording"
            :wavesurfer="wavesurfer"
            metric="negativeVibes"
            :speaker-num="speakerNum"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ChartHelper from '../utils/ChartHelper';
import RecordingVibe from '../forms/RecordingVibe';

export default {
  components: {RecordingVibe},
  mixins: [ChartHelper],
  props: ['recording', 'wavesurfer', 'speakerNum'],
};
</script>
